module.exports = __webpack_public_path__ + "static/img/bg_en.affae77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_en.jpg
// module id = QIFK
// module chunks = 2